import React, { Component } from 'react'
import Axios from 'axios';
import cachios from 'cachios'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import TopBar from '../topbar/topbar'
import search from '../assets/search.png'
import { BASE } from '../api/api';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser'
import './ongoing.css'

const url = 'http://ifdb-be.tridz.in/'

class Ongoing extends Component {

    constructor() {
        super()
        this.state = {
            ongoing: [],
            contain: '',
            limit: 10,
            offset: 0,
            length: null
        }
    }
    componentDidMount() {
        this.apicall()
        Axios.get(BASE + 'jsonapi/node/ongoing_projects?include=field_project_image,field_pdf')  //api call
            .then((data) => {
                console.log('ongoing', data.data.data)
                console.log('included', data.data.included)
                this.setState({
                    size: data.data.data.length
                })
            })
        this.setState({
            prev: false
        })

        if (this.state.offset > 10) {
            this.setState({
                prev: true
            })
        }
        if (this.state.offset > this.state.size - 1) {
            this.setState({
                next: true
            })
        }
        this.topFunction()
    }
    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    handlePageClick = data => {
        console.log(data, 'offset')
        
        if (data === 'next') {
            this.setState({
                ongoing:[],
                offset: this.state.offset + this.state.limit
            },()=>{
                this.apicall(this.state.offset)
                this.topFunction()
            })
            
            console.log(this.state.offset, 'offset in api')
            
        }
        else if (data === 'prev') {
            this.setState({
                offset: this.state.offset - this.state.limit
            },()=>{
                this.apicall(this.state.offset)
                this.topFunction()
            })
            
            
        }
    };
    apicall(offset) {
        console.log('current', offset)
        Axios.get(BASE + 'jsonapi/node/ongoing_projects?include=field_project_image,field_pdf' + '&page[limit]=10&page[offset]=' + offset)  //api call
            .then((data) => {
                console.log('ongoing', data.data.data)
                console.log('included', data.data.included)
                this.setState({
                    ongoing: data.data,
                    include: data.data.included
                })
            })
            //check next
            const offsetnext = offset +10
            Axios.get(BASE + 'jsonapi/node/ongoing_projects?include=field_project_image,field_pdf' + '&page[limit]=10&page[offset]=' + offsetnext)  //api call
            .then((data) => {
                console.log('ongoing', data.data.data)
                console.log('included', data.data.included)
                if (data.data.data.length === 0) {
                    this.setState({
                        next: false,
                    })
                }
                else {
                    this.setState({
                        next: true
                    })
                }
            })
    }
    setFilter(data) {
        console.log('filter', data)
        Axios.get(BASE + `jsonapi/node/ongoing_projects?include=field_project_image,field_pdf&filter[name][condition][path]=title&filter[name][condition][value]=${data}&filter[name][condition][operator]=CONTAINS&page[limit]=10&page[offset]=${this.state.offset}`)  //api call
            .then((data) => {
                console.log('ongoing', data.data.data)
                console.log('included', data.data.included)
                this.setState({
                    ongoing: data.data,
                    include: data.data.included
                })
            })
    }
    render() {
        return (
            <div>
                <Header />
                <div className='container'>
                    <div className='top-contents'>
                        <div className="crumbs"><Link to='/'>Home</Link> / <Link to='/report'>Ongoing Projects</Link></div>
                        {/* <TopBar data={'data1'} /> */}
                    </div>

                    <div className="page-title">
                        <div className="title-wrapper">
                            <div className="gloss_container">
                                <h1 className="heading">Ongoing Projects</h1>
                                <div className="search_input" style={{ alignSelf: 'center', marginTop: '22px', zIndex: this.state.inputhide == true ? -1 : 0 }}>
                                    <input type="text" placeholder="Search " name="search" onChange={(e) => { this.setFilter(e.target.value) }} />
                                    <div className="search_logo" style={{ top: '5px' }} onClick={() => this.apicall(this.state.offset, this.state.search)}><img src={search} height="20px" /></div>
                                </div>
                            </div>
                            {/* <div className="container">
                                    <h1 className="page-header">Articles</h1>
                                </div> */}
                        </div>
                    </div>
                    <div className='listings ongoing'>
                        {this.state.ongoing.data ?
                            <div>
                                {this.state.ongoing.data.map((data) => {
                                    let img = []
                                    let get = []
                                    let pdf = []
                                    if (this.state.ongoing.included) {
                                        img = this.state.include
                                        if (data.relationships.field_project_image.data) { get = img.filter(x => x.id === data.relationships.field_project_image.data.id) }
                                        if (img.type == 'file--document') {
                                            console.log('pdfs', img)
                                        }
                                        if (data.relationships.field_pdf.data[0]) { pdf = img.filter(x => x.id === data.relationships.field_pdf.data[0].id) }
                                        console.log('pdf', data.relationships.field_pdf.data[0])
                                    }
                                    // const img = this.state.ongoing.included
                                    // const get = Object.values(img).filter(x => x.id === data.relationships.field_project_image)
                                    // console.log('images',get)
                                    return (
                                        <div className='ongoing-data'>
                                            <div className="title">
                                                <span className="field-content bookdiv">
                                                    <div className='image'>
                                                        {get[0] ? <img src={BASE + get[0].attributes.uri.url} /> : ""}
                                                    </div>
                                                    <div className="bookdetails">
                                                        <div className='heading2'>{pdf[0] ? <a href={BASE + pdf[0].attributes.uri.url} target="_blank">{data.attributes.title}</a> : data.attributes.title}</div>
                                                        <div>
                                                            {data.attributes.field_name_of_organization_or_me}
                                                        </div>
                                                        {data.attributes.body ? ReactHtmlParser(data.attributes.body.value) : ""}
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    )

                                })}
                            </div> : ''}
                        {this.state.ongoing.data ? this.state.ongoing.data.length ?
                            <ul className="pagination side-pagination" style={{ paddingBottom: '4%' }} >
                                <li  className="previous disabled">
                                    <a onClick={() => this.handlePageClick('prev')} style={{ color: this.state.offset > 0 ? '#165E84 ' : '', fontWeight: this.state.prev ? '500' : '', cursor: this.state.offset > 0 ? '' : 'not-allowed' }} tabindex="0" role="button" className="prev" aria-disabled="true">Previous</a>
                                </li>
                                <li  className="next">
                                    <a onClick={() => this.handlePageClick('next')} style={{ color: this.state.next ? '#165E84 ' : '', fontWeight: this.state.next ? '500' : '', cursor: this.state.next ? '' : 'not-allowed' }} tabindex="0" role="button" aria-disabled="false">Next</a>
                                </li>
                            </ul>
                            : "" : ''}
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
export default Ongoing;